// Module
var code = "<ng2-bm-reports [horse-id]=\"vm.horseId\"></ng2-bm-reports> ";
// Exports
module.exports = code;